import React from 'react';
import Card from '@material-ui/core/Card';
import '../css/DevelopmentsPage.css';

/**
 * @component The component renders the Developments page
 * @return {Component} InnovationsPage component
 */
export default function InnovationsPage() {
  return (
    <Card
      style={{
        padding: '50px',
        width: '1200px',
        margin: '30px auto 30px auto',
      }}
    >
      <div style={{borderBottom: '1px solid silver', paddingBottom: '5px'}}>
        <h1 style={{paddingBottom: '2px'}}>
          2022-23 A.I.S. Biotechnology Innovations
        </h1>
      </div>
      <br />
      <p>
        <strong>
          The Optitronic System Information Repository and Integrated Server
          (OSIRIS)
        </strong>
      </p>
      <p>
        The Advanced Intelligence Services Corporation's keystone project, the
        Optitronic System Information Repository and Integrated Server, or
        OSIRIS, is a next-generation global information base and server equipped
        with a multi-circa meta telecommunications data management capability.
        OSIRIS is a long-term information management and communications central
        services solution for use in military operating environments.
      </p>
      <p>
        <strong>Multi-Circa Metabolic Physics Communications Relay</strong>
      </p>
      <p>
        A staple development in meta communications technology, the Advanced
        Intelligence Service Corporation's multi-circa metabolic physics
        communications relay is a powerful meta telecommunications and
        information management solution, and a serious investment in America's
        real-time and long-term natural metabolic physics networks. If your
        military organization is serious about effectively managing multi-circa
        meta data, contact AIS Corp. to discuss further development of this
        topic today.
      </p>
      <p>
        <strong>
          The Terraformed Reactive Universal Locator Yield (TRULY)
        </strong>
      </p>
      <p>
        The next generation of space-based functionality has arrived.
        Introducing the Advanced Intelligence Services Corporation's Terraformed
        Reactive Universal Locator Yield, or TRULY, an accelerated physics
        spacecraft developed for extended deep-space exploration missions and
        long-term community-style living operations. This is no ordinary "tin
        can" deep space vessel: TRULY immediately addresses the obsolescence of
        rocket-assisted crafts with a pre-expression matter drive, meant to
        replace cumbersome fuel cell systems with a natural approach to
        renewable energy management. TRULY also features CGI-incepted exterior
        and interior molecular-level construction; synthetic biological
        intelligence for multi-circa navigation and information management; and
        an on-board molecular printing capabilities to access fresh natural
        resources, as well as virtually limitless scalable living space. The
        TRULY is closer to reality than some might think. Contact AIS Corp. for
        investment, development, and management details.
      </p>
      <p>
        <strong>Pre-Expression Matter Biological Printing</strong>
      </p>
      <p>
        Pre-expression matter biological printing is an exciting concept for the
        achievement of biological product fulfillment in large-scale markets on,
        and beyond Earth. The next advanced step in molecular printing, this
        developing molecular printing concept delivers a precision physical
        result using pre-expression state matter as a material source, the
        purest form of raw print material known to exist.
      </p>
      <p>
        <strong>Pre-Expression Matter Propulsion Drive</strong>
      </p>
      <p>
        Innovation abounds with the development of a pre-expression matter
        propulsion drive, produced by the Advanced Intelligence Services
        Corporation. Emulating the natural flow of physics, pre-expression state
        matter is captured into a process system for development of the
        expressant value of the raw matter and then released naturally in
        post-expression emission state, producing no physical pollutants. This
        is a primary natural process drive for use in long-term space
        exploration missions.
      </p>

      <p>
        <strong>Metabolic Physics Defense Network (MPDN)</strong>
      </p>
      <p>
        The ultimate design of any network must begin with the end in mind.
        Establishing the defense of metabolic America is an urgent and
        aggressive challenge reserved for the accelerated physicist, operations
        manager, or military-grade meta user familiar with the field behavior of
        metabolic physics terrorists, factions, and nation-states as well as
        their special interest sponsors. Metabolic physics attacks are on the
        rise and continue to become increasingly complex, especially those
        originating from state-sponsored separatist factions. Urgent funding is
        required to complete the multi-circa research necessary to facilitate
        America's Metabolic Physics Defense Network (MPDN).
      </p>
      <p>
        <strong>Artificial Intelligence Avatars In Augmented Reality</strong>
      </p>
      <p>
        The future of machine learning has arrived. Introducing the Advanced
        Intelligence Services Corporation's artificial intelligence avatars in
        virtual reality environments, a concept allowing AI avatars to navigate
        a virtual world full of information, choices, and creative concept
        outlets sure to assist artificial intelligence in helping humanity learn
        more about the Universe around us.
      </p>
      <p>
        <strong>Holographic (Artificial) Neurons</strong>
      </p>
      <p>
        The action of biological mental language is now a reality in artificial
        intelligence contexts. The Advanced Intelligence Services Corporation
        introduces the innovation of artificial holographic neurons, a
        development providing for the dynamic cognitive maneuverability of
        biological neurons in accelerated artificial intelligence and machine
        learning applications, certain to rapidly enhance and accomplish complex
        processes associated with artificial information management, function,
        and recall in the next generation of AI products designed for long-term
        applications.
      </p>
      <p>
        <strong>Optitronic Physics Data Storage</strong>
      </p>
      <p>
        The information age is about to change -- into light. Introducing the
        optitronic (light algorithm) hard data storage concept, produced by the
        Advanced Intelligence Services Corporation. Simple biological algorithms
        are trained into the achievement of symbiosis, a process cycling an
        algorithm based on environmental conditioning instead of innate
        frequency programming. A next step to positronic information storage
        drives, optitronic physics storage products are a long-term, if not
        ultimate solution to digital and biological information management.
      </p>
    </Card>
  );
}
